//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the ProcessTemplatesAfterBuild executable.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
(function () {
    "use strict";

    angular.module("app").factory("pscRequestLetterApi", PscRequestLetterApiFactory);

    PscRequestLetterApiFactory.$inject = ["apiClientFactory"];
    function PscRequestLetterApiFactory(apiClientFactory) {

        const routePrefix = "api/pscrequestletter/";

        return {
            AddAttachments: apiClientFactory.post(routePrefix + "AddAttachments/"),
            ChangesRequired: apiClientFactory.post(routePrefix + "ChangesRequired/"),
            Delete: apiClientFactory.delete(routePrefix),
            DeleteAttachment: apiClientFactory.post(routePrefix + "DeleteAttachment/"),
            DownloadAsWordDocument: apiClientFactory.getFile(routePrefix + "DownloadAsWordDocument/"),
            GetLimitationLetter: apiClientFactory.get(routePrefix + "GetLimitationLetter/"),
            GetRefusalLetter: apiClientFactory.get(routePrefix + "GetRefusalLetter/"),
            InviteInvolvedToAcknowledgeDecision: apiClientFactory.post(routePrefix + "InviteInvolvedToAcknowledgeDecision/"),
            ReadyToValidate: apiClientFactory.post(routePrefix + "ReadyToValidate/"),
            SetInvolvedHasAcknowledgedDecision: apiClientFactory.post(routePrefix + "SetInvolvedHasAcknowledgedDecision/"),
            StartLimitationLetter: apiClientFactory.post(routePrefix + "StartLimitationLetter/"),
            StartRefusalLetter: apiClientFactory.post(routePrefix + "StartRefusalLetter/"),
            UpdateLanguageCode: apiClientFactory.put(routePrefix + "UpdateLanguageCode/"),
            UpdateLetterData: apiClientFactory.put(routePrefix + "UpdateLetterData/"),
            UpdateRemarks: apiClientFactory.put(routePrefix + "UpdateRemarks/"),
        };
    }
})();
